import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { capturePHEvents } from '../analytics/posthog.analytics';
import { PH_CLASS_JOIN } from '../utils/posthog.eventNames';
import { inviteToOrJoinClass } from '../service/invite.service';
import { getCke } from '../helper/cookieHelper';
import Modal from './common/Modal';

export default function JoinClassModal({ isOpen, handleClosePopup, classData, currentUser }) {
  const [classNote, setClassNote] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const onJoin = async () => {
    const loggedUserId = getCke('userId');
    if (loggedUserId) {
      setBtnLoading(true);
      const obj = {
        classId: classData?._id ?? classData.classId._id,
        orgId: classData?.orgId ?? classData.classId.orgId,
        role: 'student',
        source: 'sharedLink',
        requesterUserId: loggedUserId,
        fullName: currentUser.fullName
      };

      if (classNote.trim() !== '') obj.requesterNotes = classNote;
      const res = await inviteToOrJoinClass(obj);
      if (res) {
        capturePHEvents(PH_CLASS_JOIN, { classData });
        enqueueSnackbar('Your request for join class is sent.', {
          variant: 'success'
        });
        window.localStorage.removeItem('fromEnroll');
        handleClosePopup();
        navigate(`${location.pathname}`);
      }
      setBtnLoading(false);
    } else {
      window.localStorage.setItem(
        'fromEnroll',
        `${location.pathname}?isJoinClass=${classData.classId._id}`
      );
      navigate('/login', { replace: true });
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClosePopup}
      cancelText="Cancel"
      actionText="Join Now"
      isCancelDisabled={btnLoading}
      isBtnLoading={btnLoading}
      onCancel={handleClosePopup}
      onAction={() => onJoin()}
      title={`Join ${classData?.name ?? classData?.classId?.name}`}
    >
      <TextField
        fullWidth
        sx={{ mb: 2 }}
        margin="dense"
        label="Note (optional)"
        type="text"
        value={classNote}
        onChange={(e) => setClassNote(e.target.value)}
      />
    </Modal>
  );
}

JoinClassModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClosePopup: PropTypes.func,
  classData: PropTypes.shape({
    _id: PropTypes.string,
    orgId: PropTypes.string,
    name: PropTypes.string,
    classId: PropTypes.shape({
      name: PropTypes.string,
      _id: PropTypes.string,
      orgId: PropTypes.string
    })
  }),
  currentUser: PropTypes.object
};
